export enum SubmitEnrollmentErrorTypes {
  ACH_DISCLOSURE_NOT_ACCEPTED = 'ACH_DISCLOSURE_NOT_ACCEPTED',
  APPLICATION_ABANDONED = 'APPLICATION_ABANDONED',
  APPLICATION_CLOSED = 'APPLICATION_CLOSED',
  APPLICANT_IN_MANUAL_REVIEW = 'APPLICANT_IN_MANUAL_REVIEW',
  AUTH_USER_NOT_FOUND = 'AUTH_USER_NOT_FOUND',
  FAILED_TO_REGISTER_USER = 'FAILED_TO_REGISTER_USER',
  INADEQUATE_DEPOSIT_AMOUNT = 'INADEQUATE_DEPOSIT_AMOUNT',
  INVALID_ADDRESS_REGION = 'INVALID_ADDRESS_REGION',
  INVALID_MAGIC_LINK_CODE = 'INVALID_MAGIC_LINK_CODE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PHONE = 'INVALID_PHONE',
  INVALID_SSN = 'INVALID_SSN',
  INVALID_TOKEN = 'INVALID_TOKEN',
  LINKED_ACCOUNT_FAILED = 'LINKED_ACCOUNT_FAILED',
  UNLINKED_ACCOUNT_FAILED = 'UNLINKED_ACCOUNT_FAILED',
  LINKED_ACCOUNT_NOT_FOUND = 'LINKED_ACCOUNT_NOT_FOUND',
  MISSING_BANKING_ACCOUNT = 'MISSING_BANKING_ACCOUNT',
  MISSING_FUNDING_ACCOUNT_DETAILS = 'MISSING_FUNDING_ACCOUNT_DETAILS',
  MISSING_FUNDING_AMOUNT = 'MISSING_FUNDING_AMOUNT',
  MISSING_VERIFICATION = 'MISSING_VERIFICATION',
  TRANSFER_FUNDS_FAILED = 'TRANSFER_FUNDS_FAILED',
  UNABLE_TO_CREATE_PLAID_LINK_TOKEN = 'UNABLE_TO_CREATE_PLAID_LINK_TOKEN',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_UNABLE_TO_ENROLL = 'USER_UNABLE_TO_ENROLL',
  NON_US_CITIZEN = 'NON_US_CITIZEN',
}

// Used in Joint Enrollment only
export type JointEnrollmentError =
  | 'INVALID_TOKEN'
  | 'INVALID_EMAIL'
  | 'APPLICATION_ABANDONED'
  | 'MANUAL_REVIEW_DOCUMENT_SUBMISSION_FAILED'
  | 'INTERNAL_ERROR'
